import React from 'react'
import { Helmet } from 'react-helmet'
// import SendEmail from '../sendemail'
import ContactEmailSend from '../components/contactForm'
import Footer from '../components/footer'
import contactbg from '../assets/office.jpg'


class Contacts extends React.Component{
    render(){
        const contactBG = {
            backgroundImage: `URL(${contactbg})`,
            backgroundPositon: 'center',
            backgroundSize: 'cover',
        }
        return(
            <div>
                <Helmet>
                    <title>Contact-us page</title>
                </Helmet>
                <section className="md:px-10 px-2 py-2 md:py-5" style={contactBG}>
                   <div className="grid grid-cols-12 pb-10 gap-6 flex items-center">
                        <div className="col-span-12 md:col-span-6">
                            <ContactEmailSend />
                        </div>
                   </div>
                </section>
                <Footer />
            </div>
            
        )
    }
}

export default Contacts;


// WEBPACK FOOTER //
// ./src/pages/contacts.jsx